import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import QueueInputs from './components/QueueInputs';

import { accessLocalStorage, exportCreateQueues, valuesAnalyze, changeViewForms, readAllTenant, getMusicOnHoldData } from '../../../services';
import { scopeByTenant } from '../../../services/tenantScope';

import '../../../libs/bulma.min.css';
import './QueuesForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';

function QueuesCreate() {
  const history = useHistory();

  const [values, setValues] = useState({
    autofill: 'yes',
    queueEntryVarQueue: 'yes',
    timeout: null,
  });
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tenants, setTenants] = useState([]);
  const [moh, setMoh] = useState([]);
  const [disableTimeout, setDisableTimeout] = useState(true);
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });

  const { changeBorderImputToRedOrNormal, changeVisibityMessages } = changeViewForms;

  const fetchMusicOnHold = async () => {
    const response = await getMusicOnHoldData();
    return response.data;
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    if (!dataUser) return history.push('/');
    const { user: { idtenant } } = dataUser;
    let fetchTenants = await readAllTenant();
    if (!fetchTenants) return;
    fetchTenants = scopeByTenant(fetchTenants, (tenant) => tenant.short_name, idtenant);
    let fetchMoh = await fetchMusicOnHold();
    fetchMoh = scopeByTenant(fetchMoh, (mohItem) => mohItem.accountcode, idtenant);
    setTenants(fetchTenants);
    setMoh(fetchMoh);
    return;
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar } = valuesAnalyze;

    if(name === 'maxlen' || name === 'announceFrequency' || name === 'minAnnounceFrequency' || name === 'wrapuptime') {
      const checkValueIsNumber = value < 1 ? false : checkNumber(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    } else {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    };
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    const isNameValue = name === 'name' ? value.toLowerCase() : value;
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = isNameValue )
    if(Object.keys(validate).length >= 12) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    if(name === 'strategy') {
      value === 'linear' ? setDisableTimeout(false) : setDisableTimeout(true);
    };
    return;
  };

  const sendDataQueueGenerate = async () => {
    setSaving(true);
    setAlert({ show: false, type: '', message: '' });

    const result = await exportCreateQueues(values);

    if (!result.success) {
      setSaving(false);
      setAlert({ show: true, type: 'danger', message: result.error });
      return;
    }

    setAlert({ show: true, type: 'success', message: 'Fila criada com sucesso!' });
    setTimeout(() => {
      history.push('/config/fila/lista');
    }, 2000);
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div className="queues-form-container">
      <div className="queues-form-header">
        <div className="queues-form-title-wrapper">
          <svg className="queues-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <div>
            <h1 className="queues-form-title">Adicionar Fila</h1>
            <p className="queues-form-subtitle">Crie um novo grupo atendedor</p>
          </div>
        </div>
      </div>

      {alert.show && (
        <div className="alerts-section">
          <div className={`alert-message alert-${alert.type}`}>
            <div className="alert-header">
              <span>{alert.type === 'success' ? 'Sucesso!' : 'Erro!'}</span>
              <button className="alert-close" aria-label="delete" onClick={() => setAlert({ show: false, type: '', message: '' })}>×</button>
            </div>
            <div className="alert-body">
              {alert.message}
            </div>
          </div>
        </div>
      )}

      <div className="form-card">
        <QueueInputs
          changeValues={handleChangeValues}
          tenants={tenants}
          moh={moh}
          disableTimeout={disableTimeout}
        />

        <div className="form-actions">
          <button className="btn-submit" type="submit" disabled={disable || saving} onClick={() => sendDataQueueGenerate()}>
            <FontAwesomeIcon icon={faPhoneSquare} />
            <span>{saving ? 'Criando...' : 'Criar Grupo Atendedor'}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default QueuesCreate;
